import { useState, useEffect } from "react";

const PAIRS = [
  {
    id: 1,
    title: "Eksempel 1 – Position ca. 5,10 meter",
    position: "ca. 5,10 m",
    before: {
      url: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/170918-1014a-survey.webp",
      caption: "Før reparation",
      description: "Eksisterende kloakrør før reparation. Tydelig rund sideåbning/tilslutning i den ældre rørflade."
    },
    after: {
      url: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/170918-1146a-survey.webp",
      caption: "Efter reparation",
      description: "Samme område efter arbejdet. Rørets indvendige overflade er nu beklædt med en lys, glat liner (position ca. 5,10 m)."
    }
  },
  {
    id: 2,
    title: "Eksempel 2 – Position ca. 0,44 meter",
    position: "ca. 0,44 m",
    before: {
      url: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/170918-1054a-survey.webp",
      caption: "Før reparation",
      description: "Eksisterende rør og rund åbning/tilslutning før reparation."
    },
    after: {
      url: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/170918-1223a-survey.webp",
      caption: "Efter reparation",
      description: "Området efter reparation med en ny, lys og ensartet indvendig liner."
    }
  },
  {
    id: 3,
    title: "Eksempel 3 – Position ca. 0,08 meter",
    position: "ca. 0,08 m",
    before: {
      url: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/170918-1055a-survey.webp",
      caption: "Før reparation",
      description: "Eksisterende røråbning og den ældre indvendige rørflade."
    },
    after: {
      url: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/170918-1224a-survey.webp",
      caption: "Efter reparation",
      description: "Samme position efter reparation med en lys, glat liner."
    }
  }
];

export default function BeforeAfterPairs() {
  const [lightboxImage, setLightboxImage] = useState(null);

  useEffect(() => {
    if (!lightboxImage) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setLightboxImage(null);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightboxImage]);

  return (
    <section className="my-10 pt-6 border-t border-neutral-200">
      <div className="mb-6">
        <span className="text-xs font-bold uppercase tracking-wider text-neutral-500 block mb-1">
          Dokumentation & Resultater
        </span>
        <h3 className="text-xl sm:text-2xl font-bold text-neutral-900">
          Før og efter punktreparation
        </h3>
        <p className="text-sm text-neutral-600 mt-1 max-w-2xl">
          Konkrete TV-inspektionsbilleder fra tre separate reparationer, der viser rørets tilstand før og efter indsættelse af partiel liner.
        </p>
      </div>

      <div className="space-y-8">
        {PAIRS.map((pair) => (
          <div
            key={pair.id}
            className="bg-neutral-50 border border-neutral-200 rounded-xl p-4 sm:p-6 shadow-xs"
          >
            {/* Header for eksemplet */}
            <div className="flex flex-wrap items-center justify-between gap-2 pb-4 mb-4 border-b border-neutral-200">
              <h4 className="font-bold text-neutral-900 text-base flex items-center gap-2">
                <i className="fa-solid fa-camera text-neutral-500" aria-hidden="true" />
                <span>{pair.title}</span>
              </h4>
              <span className="inline-flex items-center text-xs font-semibold px-2.5 py-1 rounded bg-neutral-200 text-neutral-800">
                Position: {pair.position}
              </span>
            </div>

            {/* Før / Efter Grid - 2 kolonner på desktop, stablet på mobil */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              
              {/* FØR BOKS */}
              <div className="flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-neutral-900 text-white font-extrabold text-xs uppercase tracking-wider">
                    <span className="w-2 h-2 rounded-full bg-amber-400" aria-hidden="true" />
                    FØR
                  </span>
                  <span className="text-xs text-neutral-500 font-medium">Inspektion før udbedring</span>
                </div>

                <button
                  type="button"
                  onClick={() =>
                    setLightboxImage({
                      url: pair.before.url,
                      title: `${pair.title} – FØR`,
                      desc: pair.before.description
                    })
                  }
                  className="group relative block w-full aspect-4/3 rounded-lg overflow-hidden bg-[#090d12] border border-neutral-300 focus:outline-none focus:ring-2 focus:ring-neutral-400 cursor-pointer shadow-xs"
                  aria-label={`Vis forstørret før-billede for ${pair.title}`}
                >
                  <img
                    src={pair.before.url}
                    alt={`${pair.title} – Før reparation`}
                    className="w-full h-full object-contain p-1 transition-transform duration-300 group-hover:scale-102"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <span className="opacity-0 group-hover:opacity-100 transition-opacity bg-black/80 text-white text-xs font-semibold px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow">
                      <i className="fa-solid fa-magnifying-glass-plus" aria-hidden="true" />
                      <span>Forstør foto</span>
                    </span>
                  </div>
                </button>

                <p className="text-xs text-neutral-600 mt-2.5 leading-relaxed">
                  {pair.before.description}
                </p>
              </div>

              {/* EFTER BOKS */}
              <div className="flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-neutral-900 text-white font-extrabold text-xs uppercase tracking-wider">
                    <span className="w-2 h-2 rounded-full bg-emerald-400" aria-hidden="true" />
                    EFTER
                  </span>
                  <span className="text-xs text-neutral-500 font-medium">Efter udført punktreparation</span>
                </div>

                <button
                  type="button"
                  onClick={() =>
                    setLightboxImage({
                      url: pair.after.url,
                      title: `${pair.title} – EFTER`,
                      desc: pair.after.description
                    })
                  }
                  className="group relative block w-full aspect-4/3 rounded-lg overflow-hidden bg-[#090d12] border border-neutral-300 focus:outline-none focus:ring-2 focus:ring-neutral-400 cursor-pointer shadow-xs"
                  aria-label={`Vis forstørret efter-billede for ${pair.title}`}
                >
                  <img
                    src={pair.after.url}
                    alt={`${pair.title} – Efter reparation`}
                    className="w-full h-full object-contain p-1 transition-transform duration-300 group-hover:scale-102"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <span className="opacity-0 group-hover:opacity-100 transition-opacity bg-black/80 text-white text-xs font-semibold px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow">
                      <i className="fa-solid fa-magnifying-glass-plus" aria-hidden="true" />
                      <span>Forstør foto</span>
                    </span>
                  </div>
                </button>

                <p className="text-xs text-neutral-600 mt-2.5 leading-relaxed">
                  {pair.after.description}
                </p>
              </div>

            </div>
          </div>
        ))}
      </div>

      {/* Lightbox Modal */}
      {lightboxImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex flex-col items-center justify-center p-4 sm:p-6 select-none animate-in fade-in duration-200"
          onClick={() => setLightboxImage(null)}
        >
          <div
            className="w-full max-w-4xl flex items-center justify-between text-white mb-3"
            onClick={(e) => e.stopPropagation()}
          >
            <div>
              <h5 className="font-bold text-sm sm:text-base">{lightboxImage.title}</h5>
              <p className="text-xs text-neutral-400">{lightboxImage.desc}</p>
            </div>
            <button
              type="button"
              onClick={() => setLightboxImage(null)}
              className="p-2 text-neutral-300 hover:text-white rounded-lg hover:bg-neutral-800 transition-colors"
              aria-label="Luk visning"
            >
              <i className="fa-solid fa-xmark text-2xl" aria-hidden="true" />
            </button>
          </div>

          <div
            className="relative w-full max-w-4xl max-h-[80vh] flex items-center justify-center bg-black rounded-lg overflow-hidden border border-neutral-800"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightboxImage.url}
              alt={lightboxImage.title}
              className="max-w-full max-h-[78vh] object-contain rounded mx-auto"
            />
          </div>
        </div>
      )}
    </section>
  );
}
